// @flow
import {CENTRIFUGE_MODULE_NAME} from 'modules/centrifuge/constants';
import type {TCentrifugeConnectionData, TCentrifugeState} from 'modules/centrifuge/reducers';
import type {TRootState} from 'types';

/**
 * Возвращает модуль центрифуги
 * @param state стор
 * @return возвращает модуль центрифуги
 */
function selectModule(state: TRootState): TCentrifugeState {
    return state[CENTRIFUGE_MODULE_NAME];
}

/**
 * Возвращает булево значение подключена ли центрифуга
 * @param state стор
 * @return подключена ли центрифуга
 */
function selectIsConnected(state: TRootState): boolean {
    return selectModule(state).isConnected;
}

/**
 * Возвращает значение закончилось ли подключение к центрифуге
 * @param state стор
 * @return закончилось ли подключение к центрифуге
 */
function selectConnectionInProcess(state: TRootState): boolean {
    return selectModule(state).connectionInProcess;
}
/**
 * Возвращает данные для подключения к центрифуге
 * @param state стор
 * @return данные для подключения к центрифуге
 */
function selectConnectionData(state: TRootState): ?TCentrifugeConnectionData {
    return selectModule(state).connectionData;
}

export {selectIsConnected, selectConnectionInProcess, selectConnectionData};
